import React, { useState } from 'react';

import { useCustomDashboardTiles } from '../CustomWidgets/CustomWidgets.hooks';
import { useMyJourney } from '../Dashboard.hooks';
import { useUpdateHiddenDashboardWidgets } from './DashboardSettings.hooks';
import { useHiddenDashboardWidgets } from './DashboardSettings.hooks';
import { Container } from './DashboardSettings.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { LinkButton } from 'components/v2/Buttons/LinkButton/LinkButton';
import { DropdownIcon } from 'components/v2/DropdownMenu/Dropdown.styled';
import { usePatient } from 'hooks/usePatient/usePatient';
import useResults from 'hooks/useResults';

import { DashboardWidgetList } from './DashboardSettings.types';
import { SettingsModal } from './SettingsModal';
import { showCustomTile } from '../CustomWidgets/CustomWidgets.utils';

interface Props {
  hideSettings: boolean;
  buttonLabel?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md';
}

export const DashboardSettings = ({ hideSettings, buttonLabel, fullWidth, size = 'sm' }: Props) => {
  const [open, setOpen] = useState(false);
  const { patient, loading: loadingUser } = usePatient();
  const { data: hiddenWidgets, loading: loadingHiddenWidgets } = useHiddenDashboardWidgets();
  const { data: journeyData, loading: loadingJourney } = useMyJourney();
  const results = useResults();
  const { data: customTiles, loading: loadingCustomTiles } = useCustomDashboardTiles();
  const { updateHiddenDashboardWidgets, loading: updatingHiddenWidgets } =
    useUpdateHiddenDashboardWidgets();

  const displayableCustomTiles = customTiles?.customDashboardTiles.filter(showCustomTile) ?? [];

  const handleSave = (hiddenWidgets: DashboardWidgetList) => {
    updateHiddenDashboardWidgets({
      variables: {
        hiddenDashboardWidgets: hiddenWidgets
      }
    }).finally(() => setOpen(false));
  };

  if (!patient) return null;

  const showLoader =
    updatingHiddenWidgets ||
    loadingHiddenWidgets ||
    loadingUser ||
    loadingJourney ||
    loadingCustomTiles ||
    results.loading;

  return (
    <Container $buttonTrigger={Boolean(buttonLabel)}>
      {!hideSettings &&
        (buttonLabel ? (
          <Button
            category="secondary"
            label={buttonLabel}
            onClick={() => setOpen(true)}
            size={size}
            fullWidth={fullWidth}
          />
        ) : (
          <LinkButton leftIcon={<DropdownIcon />} size="sm" onClick={() => setOpen(true)} />
        ))}

      {/*
        mount/unmount the whole modal from outside because the DashboardSettings component is rendered in
        multiple places(widgets) at the same time. We don't need to have multiple modals rendered(but closed) at the same time.
      */}
      {open && (
        <SettingsModal
          hiddenWidgets={hiddenWidgets ?? []}
          onClose={() => setOpen(false)}
          onSave={handleSave}
          showLoader={showLoader}
          patient={patient}
          journey={journeyData}
          results={results}
          customTiles={displayableCustomTiles}
        />
      )}
    </Container>
  );
};
